import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';
import keycloakManager from '../keycloak';
import { useParams, useNavigate } from 'react-router-dom';

const AuthedRoute = ({ roles, element }) => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const params = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      if (!keycloakManager.isAuthenticated) {
        await keycloakManager.login();
      }
      setLoading(false);
    };

    checkAuth();
  }, []);

  if (loading) {
    return <div>Loading...</div>; // Replace with a loading spinner if desired
  }

  if (!keycloakManager.isAuthenticated) {
    return <Navigate to="/401" state={{ from: location }} replace />;
  }

  if (!keycloakManager.isInGroup(roles)) {
    return <Navigate to="/401" state={{ from: location }} replace />;
  }

 // return element; // Render the element if authenticated and authorized
 return React.cloneElement(element, { params,navigate});
};

AuthedRoute.propTypes = {
  roles: PropTypes.array,
  element: PropTypes.element.isRequired,
};

export default AuthedRoute;
